import './cart.css'
import sample from '../assets/samples/s1.png'
import options from '../assets/icon/options.png'
import darrow from '../assets/icon/darrow.png'
import uparrrow from '../assets/icon/uparrow.png'

import { useState,useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ViewImages from '../Fabric/View/viewImages';
import body from '../assets/samples/body2.png'
import def_shirt from '../assets/samples/shirt/SHIRT.png'

import aim from '../assets/samples/anima.gif'
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

import pant_body from '../assets/Body/pant_body.png'
import formal_body from '../assets/Body/pant_shirt_formal_body.jpg'

import default_shirt_formal from '../assets/samples/shirt_1.png'
import default_pant_formal from '../assets/samples/pant_1.png'

import kurta_body from '../assets/Body/kurta_body.png'
import sadri_def from '../assets/Body/sadri_def.png'

import pant_body_new from '../assets/Body/body_for_pant.jpg'

import { Types } from '../Data';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

function Cartcard({item, deleteFromCart, setModalItem, toggle}) {
    

    const counter = useRef(0);
    
    const [expand, setExpand] = useState(0)
    const navigate = useNavigate()
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    const [load, setLoad] = useState(true)

    const [items, setItems] = useState()

    const [def_body, setDefBody] = useState(
        item.category === "suit" ? body 
        : item.category === "formal" ? formal_body 
        : item.category === "shirt" ? formal_body 
        : item.category === "pant" ? pant_body_new
        : item.category === "kurta" ? kurta_body 
        : item.category === "sadri" ? kurta_body 
        : body
        );
    
    const [def_cloth, set_def_shirt] = useState(
        item.category === "suit" ? def_shirt
        : item.category === "formal" ? default_pant_formal
        : item.category === "pant" ? default_shirt_formal
        : item.category === "shirt" ? default_pant_formal
        : item.category === "sadri" ? sadri_def
        : def_shirt
    )

    useEffect(()=>{
        if(item && Object.keys(item).includes("item_type") && item["item_type"] === 1 ){
            let a = []

            item.fabrics.forEach(element => {
                if(!a.includes(element.type)){
                    a.push(element.type)
                }
            });
            setItems(a)
        }
    }, [])

    useEffect(()=>{
        setDefBody(
            item.category === "suit" ? body 
            : item.category === "formal" ? formal_body 
            : item.category === "shirt" ? formal_body 
            : item.category === "pant" ? pant_body_new
            : item.category === "kurta" ? kurta_body 
            : item.category === "sadri" ? kurta_body 
            : body
        )

        set_def_shirt(
            item.category === "suit" ? def_shirt
            : item.category === "formal" ? default_pant_formal
            : item.category === "pant" ? default_shirt_formal
            : item.category === "shirt" ? default_pant_formal
            : item.category === "sadri" ? sadri_def
            : def_shirt
        )
    }, [item])

    useEffect(()=>{
        setLoad(true)
    }, [toggle])
    const imageLoaded = () => {
        counter.current += 1;
        let L
        
        if(Object.keys(item).includes("item_type")){
            L=1;
        }else{
            L = item.types.length;
        }

        if (counter.current >= L) {
            setLoad(false);
            counter.current = 0;
        }
    }

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    return (
    <div className="cart-card">
        {/* Type Badge */}
        <Tooltip TransitionComponent={Zoom} 
        title= {Object.keys(item).includes("item_type") && item.item_type === 0 ? "Fabric Only" 
            : Object.keys(item).includes("item_type") && item.item_type === 1 ? "Preset": "Custom Suit"
            }
        >
        <div style={{position: 'absolute', top: '10px', left: '10px', zIndex: 10, background: '#14213D', color: 'white', width: '30px', height: '30px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8rem', fontWeight: 'bold'}}>
            {Object.keys(item).includes("item_type") && item.item_type === 0 ? "F" 
            : Object.keys(item).includes("item_type") && item.item_type === 1 ? "P": "C"
            }
        </div>
        </Tooltip>

        <div className='cart-img'>
            {load && (
                <div style={{position:"absolute", top: 0, left: 0, height:"100%", width:"100%", background:"#f3f4f6", display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5}}>
                    <img alt="loading" src={aim} onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'" style={{width: '50px'}}/>
                </div>
            )}
            
            <div style={{"position":"relative", "width":"100%", "height":"100%", "objectFit":"contain", overflow:"hidden"}} className='verti_center'>
            
            {Object.keys(item).includes("item_type") && item.item_type === 1 ? 
                /* Presets */
                <img src={ item.src } onLoad={imageLoaded} className= {"v-display-img-full"} />
                : Object.keys(item).includes("item_type") && item.item_type === 0 ? 
                /* Fabric feel */
                <img src={ item.src } onLoad={imageLoaded} className= {"v-display-img-full"} />
                : 
                /* Custom */
                <>
                    {(!load && !toggle )&& <img src={ def_body } className= {`v-display-img-full img-left cart-v-display-img-${item.category} }`}/>}
                    {(!load && !toggle && item.category != "kurta" && item.category != "formal" ) && <img src={ def_cloth } className= {`v-display-img-full img-left def_cloth-${item.category} cart-v-display-img-${item.category}`}/>}
                    { item.category === "blazer" && 
                        <img src={"https://firebasestorage.googleapis.com/v0/b/maviinvi.appspot.com/o/Suits%2FPant%2FPANT-1726940263526?alt=media&token=080a27a0-2fa6-4428-a573-280768af3313"} 
                        className= {`v-display-img-full img-left def_cloth-${item.category} cart-v-display-img-${item.category}`}
                        />
                    }
                    {item && item.types.map((val, key)=>{
                        return(
                            <>
                                {item.fabric[val] && item.fabric[val].src && Array.isArray(item.fabric[val].src) ?
                                    <>
                                    {item.fabric[val].src.map((values, keys)=>{
                                        return(
                                            <img src={ values } onLoad={imageLoaded} style={ {"zIndex":50-item.fabric[val]["pos"]} } className= {`v-display-img-full img-left cart-v-display-img-${item.category}`}/>
                                        )
                                    })} 
                                    </>
                                    : <img src={ item && item.fabric && Object.hasOwn(item.fabric, val) ? item.fabric[val]["src"] : "" } onLoad={imageLoaded} style={ {"zIndex":50-item.fabric[val]["pos"]} } className= {`v-display-img-full img-left cart-v-display-img-${item.category}`}/>
                                }
                            </>
                        )
                    })}
                </>
            }
            </div>
        </div>
        
        <div className="cart-details">
            <div>
                <div className="cart-title">
                    {item.name ? item.name: item.type}
                </div>
                
                <div className="cart-subtitle">
                    {!Object.keys(item).includes("item_type") && 
                        <div>
                            Items: {item.types && item.types.join(", ")}
                        </div>
                    }

                    {Object.keys(item).includes("item_type") && item.item_type === 1 &&
                        <div>
                            Items: {items && items.join(", ")}
                        </div>
                    }

                    {Object.keys(item).includes("item_type") && item.item_type === 0 &&
                        <div>
                            Fabrics: {item.items.length}/5 <br/>
                            <span style={{color:"#16a34a", fontWeight: '500'}}>+ Free Measuring tape</span>
                        </div>
                    }
                    
                    <div style={{color:"#16a34a", marginTop: '5px', fontSize: '0.85rem'}}>
                        Estimated Delivery: { (new Date(  (new Date().setDate( (new Date()).getDate() +13 )) )).toDateString() }
                    </div>
                </div>
            </div>
            
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                <div className="cart-actions">
                    <button className='cart-btn-text' onClick={()=>{ deleteFromCart(item.id) }}>
                        Remove
                    </button>

                    {(Object.keys(item).includes("item_type") && item.item_type===0) &&  
                        <>
                            <div style={{width: '1px', height: '15px', background: '#e5e7eb'}}></div>
                            <button className='cart-btn-text' onClick={()=>{ setModalItem({...{ "s":true }, ...item}) }}>
                                Details
                            </button>
                        </>
                    }
                    
                    {((Object.keys(item).includes("item_type") && item.item_type!=0) || !Object.keys(item).includes("item_type") ) && (
                        <>
                            <div style={{width: '1px', height: '15px', background: '#e5e7eb'}}></div>
                            <button className='cart-btn-text' onClick={() => setExpand(expand === 0 ? 1 : 0)}>
                                Measurements
                            </button>
                        </>
                    )}
                </div>

                <div className='cart-price'>
                    {
                        !Object.keys(item).includes("item_type") && !toggle ?
                        ((Number(item.price)-Number(item.discount))).toLocaleString('en-IN', { maximumFractionDigits: 2, style: 'currency', currency: 'INR' })
                        : ((Number(item.price) - (Number(item.price)*Number(item.discount)/100))).toLocaleString('en-IN', { maximumFractionDigits: 2, style: 'currency', currency: 'INR' })
                    }
                    {(item.discount > 0) && (
                        <div style={{fontSize:"0.8rem", color:"#16a34a", fontWeight: 'normal', textAlign: 'right'}}> 
                            Saved { !Object.keys(item).includes("item_type") && !toggle ? `${ Math.round( (  Number(item.discount)/Number(item.price) )*100 ) } %` : `${ Math.round(Number(item.discount)) } %` }
                        </div>
                    )}
                </div>
            </div>
        </div>

        { expand == 1 && (
            <div style={{position: 'absolute', top: '100%', left: 0, width: '100%', background: '#f9fafb', padding: '1rem', border: '1px solid #e5e7eb', borderTop: 'none', zIndex: 10}}>
                <div style={{marginBottom: '0.5rem', fontWeight: '600'}}>Measurements</div>
                {item && item["measurements"]["type"] == 0 ? (
                    <div style={{fontSize: '0.9rem', lineHeight: '1.6'}}>
                    { (Types[item.category]["measurement"] === 0 || Types[item.category]["measurement"] === 2) &&  <div>
                        Upper Body : {item["measurements"]["upper_body"]}
                    </div>}
                    { (Types[item.category]["measurement"] === 1 || Types[item.category]["measurement"] === 2) && <div>
                        Lower Body : {item["measurements"]["lower_body"]}
                    </div>}
                    </div>
                ) : item && item["measurements"]["type"] == 1 ? (
                    <div style={{fontSize: '0.9rem', lineHeight: '1.6', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem'}}>
                        { (Types[item.category]["measurement"] === 0 || Types[item.category]["measurement"] === 2) &&<div>
                            <b>Upper Body </b> <br/>
                            Sleeve Length: {item["measurements"]["upper_body"]["sleeve_length"]}<br/>
                            Chest Around: {item["measurements"]["upper_body"]["chest_around"]}<br/>
                            Neck: {item["measurements"]["upper_body"]["neck"]}<br/>
                            Shoulder Width: {item["measurements"]["upper_body"]["shoulder_width"]}<br/>
                            Stomach: {item["measurements"]["upper_body"]["stomach"]}<br/>
                            Length: {item["measurements"]["upper_body"]["length"]}<br/>
                            Hip: {item["measurements"]["upper_body"]["hip"]}<br/>
                            Bicep: {item["measurements"]["upper_body"]["bisep"]}<br/>
                        </div>}
                        { (Types[item.category]["measurement"] === 1 || Types[item.category]["measurement"] === 2) && <div>
                            <b>Lower Body </b> <br/>
                            Leg Length: {item["measurements"]["lower_body"]["leg_length"]}<br/>
                            Waist: {item["measurements"]["lower_body"]["waist"]}<br/>
                            Hip: {item["measurements"]["lower_body"]["hip"]}<br/>
                            Circle: {item["measurements"]["lower_body"]["circle"]}<br/>
                            Thigh: {item["measurements"]["lower_body"]["thigh"]}<br/>
                            Bottom: {item["measurements"]["lower_body"]["bottom"]}<br/>
                        </div>}
                    </div>
                ) : (<div style={{fontSize: '0.9rem'}}> You choose to clone a cloth. You will be providing us a {item.category} piece of yours from which we will get the measurements. Add Pickup location at the time of checkout and our deliver partner will pick your piece </div>)
                }
            </div>
        )}
    </div>
    );
}

export default Cartcard;